import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCarteraSucursal, getDistritos, getRegiones, getSucursales } from "../../Services/byte_service";
import { setShowBackdrop } from "../uiSlice";
import { setCarteraActiva, setClientesSeleccionados } from "../Capacitacion/capacitacionSlice";

const initialState = {
    distritos: [],
    regiones: [],
    sucursales: [],
    sucursalesSelecciondas: [],
    carteraSucursal: [],
}

export const byteSlice = createSlice({
    name: 'byte',
    initialState,
    reducers: {
        setDistritos: (state, action) => {
            state.distritos = action.payload;
        },
        setRegiones: (state, action) => {
            state.regiones = action.payload;
        },
        setSucursales: (state, action) => {
            state.sucursales = action.payload;
        },
        setSucursalesSeleccionadas: (state, action) => {
            state.sucursalesSelecciondas = action.payload;
        },
        setCarteraSucursal: (state, action) => {
            state.carteraSucursal = action.payload;
        },
        resetByteState: () => initialState,
    }
});


export const carteraChange = createAsyncThunk(
    'byte/cartera/change',
    async (data, { dispatch }) => {
        dispatch(setShowBackdrop(true));
        await dispatch(fetchCarteraSucursal(data));
        await dispatch(setClientesSeleccionados([]));
        dispatch(setShowBackdrop(false));
    }
);

export const fetchDistritos = createAsyncThunk(
    'byte/fetchDistritos',
    async (_, { dispatch }) => {
        const distritosRes = await getDistritos();
        dispatch(setDistritos(distritosRes));
    }
);

export const fetchRegiones = createAsyncThunk(
    'byte/fetchRegiones',
    async (_, { dispatch }) => {
        const regionesRes = await getRegiones();
        dispatch(setRegiones(regionesRes));
    }
);

export const fetchSucursales = createAsyncThunk(
    'byte/fetchSucursales',
    async (_, { dispatch }) => {
        const sucursalesRes = await getSucursales();
        dispatch(setSucursales(sucursalesRes));
    }
);

export const fetchCarteraSucursal = createAsyncThunk(
    'byte/fetchCarteraSucursal',
    async (data, { dispatch }) => {
        dispatch(setCarteraActiva(data.idSucursal))
        const carteraRes = await getCarteraSucursal(data);
        dispatch(setCarteraSucursal(carteraRes));
    }
);

export const { setDistritos, setRegiones, setSucursales, setSucursalesSeleccionadas, setCarteraSucursal, resetByteState } = byteSlice.actions;
export default byteSlice.reducer;